import { createSelector } from 'reselect';

import { RootState } from 'types/RootState.types';
// Config
import { getSelectedPaymentTypeSelector } from '@redux/reducers/payment/paymentSelector';
import { getSavedPaymentCardsSelector } from '@redux/reducers/user/userSelector';
import {
  getPosCreditBasketExcessSelector,
} from '@redux/reducers/order-form/orderFormSelector';
import { getRouterLocationPathname } from '@redux/reducers/router/routerSelector';
import { shouldShowPOSCBasketExcess } from '@utils/orderform/shouldShowPOSCBasketExcess';

const getShouldShowPOSCBasketExcessSelector = (state: RootState) => shouldShowPOSCBasketExcess(state);

const posCreditOptionsState = createSelector(
  [
    getSavedPaymentCardsSelector,
    getSelectedPaymentTypeSelector,
    getPosCreditBasketExcessSelector,
    getRouterLocationPathname,
    getShouldShowPOSCBasketExcessSelector,
  ],
  (
    savedPaymentCards,
    selectedPaymentType,
    posCreditBasketExcess,
    pathname,
    shouldShowPOSCBasketExcess,
  ) => ({
    ...(shouldShowPOSCBasketExcess && { pathname, posCreditBasketExcess }),
    savedPaymentCards,
    selectedPaymentType,
  }),
);

export default posCreditOptionsState;
